import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Field, change } from 'redux-form';
import Button from '../../elements/Button';
import styles from './styles.scoped.css';
import { fieldsProps } from './schema';
import Text from '../../fields/Text';
import { useEditMerchant } from '../../../pages/SettingMerchant/hooks';
import Select from '../../fields/SelectBox';
import { useDebounce } from '../../../utils/hooks';
import { fetchListBanks } from '../../layouts/PageBase/actions';
import { Loader } from '@mantine/core';
import {
  setMessageAction,
  validateBankAccount,
} from '../../../pages/SettingMerchant/actions';

export default function EditBankForm({
  handleOpenModal,
  // handleSubmit = () => {},
  // initialValues = {},
  // invalid = true
}) {
  const { accountName, accountNumber, bankName } = fieldsProps;
  const dispatch = useDispatch();
  const {
    syncErrors,
    anyTouched = false,
    values,
    fields
  } = useSelector((state) => state.form.formEditBank);
  const {
    edit: { message, loading },
    bank: validate,
  } = useSelector((state) => state.merchantSetting);
  const { isValid, isChecked } = validate.data;
  const { dataBanks, isLoadingBanks } = useSelector((state) => state.pageBase);
  const hasErrorField =
    anyTouched && (syncErrors.accountName || syncErrors.accountNumber);
  const { handleCancel } = useEditMerchant('formEditBank');
  const [searchBank, setSearchBank] = useState('');
  const debounceBank = useDebounce(searchBank, 500);

  const handleCheck = () => {
    const { accountNumber, bankName } = values;
    const bankCode = dataBanks.find(({ value }) => value === bankName)?.code;
    dispatch(validateBankAccount({ accountNumber, bankCode }));
  };

  useEffect(() => {
    dispatch(fetchListBanks());
  }, []);

  useEffect(() => {
    dispatch(fetchListBanks(debounceBank));
  }, [debounceBank]);

  useEffect(() => {
    const accountName =
      isValid && isChecked !== undefined ? validate.data?.accountName : '';

    if (isChecked) {
      dispatch(change('formEditBank', 'accountName', accountName));
    }
    dispatch(setMessageAction({ key: 'bank', message: '' }));
  }, [isValid, isChecked, validate.data?.accountName, validate.success]);

  useEffect(() => {
    if(fields?.accountNumber || fields?.bankName) {
      dispatch(change('formEditBank', 'accountName', ''));
    }
  }, [fields?.accountNumber, fields?.bankName]);

  return (
    <form className={styles.form} encType="multipart/form-data">
      <div>
        {message ? <p className={styles.error}>{message}</p> : null}
        <div className={styles.fields}>
          <Field
            clearable
            component={Select}
            data={dataBanks}
            inputProps={bankName}
            name={bankName.name}
            onChange={(e) => e === null && setSearchBank('')}
            onSearchChange={(e) => setSearchBank(e.target.value)}
            rightSection={isLoadingBanks && <Loader size="xs" />}
          />
          <Field
            component={Text}
            disabled
            inputProps={accountNumber}
            name={accountNumber.name}
          />
          <div>
            <label style={{ visibility: 'hidden' }}>Check Rekening</label>
            <Button
              className={[
                'button__check',
                hasErrorField && 'invalid',
              ].join(' ')}
              disabled={validate.loading || !values.bankName}
              onClick={handleCheck}
              style="default"
              type="button"
            >
              Cek Rekening
            </Button>
          </div>
          <Field
            component={Text}
            inputProps={accountName}
            name={accountName.name}
          />
        </div>
      </div>
      <div className={styles.actions}>
        <Button
          disabled={loading}
          onClick={handleCancel}
          style="default"
          type="button"
        >
          Batalkan
        </Button>
        <Button
          disabled={loading || !isValid || isChecked === undefined || !values.accountName}
          onClick={handleOpenModal}
          type="button"
        >
          Simpan
        </Button>
      </div>
    </form>
  );
}

EditBankForm.propTypes = {
  handleOpenModal: PropTypes.func,
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  invalid: PropTypes.bool,
};
